import { Button, Card, Drawer } from "antd";
import React, { useEffect, useState } from "react";
import { AddonServices } from "../Services/AddonServices";
import { notify } from "../customs/NotifyProvider";
import OfferTable from "../components/Offers/OfferTable";
import CreateOffer from "../components/Offers/CreateOffer";
import CreateDriver from "../components/Driver/CreateDriver";
import DriverTable from "../components/Driver/DriverTable";

const DriverPage = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);

  const getAddonServices = async () => {
    try {
      const request = await AddonServices.getAllDriver();
      setData(request.data);

      console.log(request.data);

    } catch (error) {
      console.error(error);

    }
  }

  const handleEdit = (id) => {
    try {
      // const request = await 
      console.log(id);
      setEditId(id);
      setOpen(true);

    } catch (error) {
      console.error(error);

    }
  }
  const handleDelete = async (id) => {
    try {
      const req = await AddonServices.deleteDriverById(id);
      if (req.status) {
        notify.success("Deleted", req.message)
        getAddonServices()
      } else {
        notify.error("Something went wrong!", req.message)
        getAddonServices()
      }
      console.log(id);

    } catch (error) {
      console.error(error);

    }
  }

  useEffect(() => {
    getAddonServices();
  }, [])

  return (
    <>
      <Card
        title="Manage Driver"
        extra={
          <Button
            type="primary"
            ghost
            onClick={() => setOpen(true)}
          >
            Create Driver
          </Button>
        }
      >
        <DriverTable data={data}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      </Card>


      <Drawer
        title={editId ? "Edit Driver" : "Create Driver"}
        width={520}
        open={open}
        onClose={() => {
          setOpen(false);      // close drawer
          setEditId(null);     // clear editId
        }}
        destroyOnClose
      >
        <CreateDriver
          closeDrawer={() => {
            setOpen(false);
            setEditId(null);   // ensure data cleared if closing from inside AddSS
          }}
          getAddonServices={getAddonServices}
          editorId={editId}
        />
      </Drawer>
    </>
  );
};

export default DriverPage;
